// src/components/admin/SlideMenu.tsx
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  List, ListItemButton, ListItemIcon, ListItemText,
  Box, IconButton, Chip, Collapse, CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InventoryIcon from '@mui/icons-material/Inventory';
import SettingsIcon from '@mui/icons-material/Settings';
import GavelIcon from '@mui/icons-material/Gavel';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ViewCarouselOutlinedIcon from '@mui/icons-material/ViewCarouselOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import CreditScoreOutlinedIcon from '@mui/icons-material/CreditScoreOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import GroupIcon from '@mui/icons-material/Group';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import StarsIcon from '@mui/icons-material/Stars';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import SecurityIcon from '@mui/icons-material/Security';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import LayersIcon from '@mui/icons-material/Layers';
import DiscountIcon from '@mui/icons-material/Discount';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import Whatshot from '@mui/icons-material/Whatshot';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import PercentIcon from '@mui/icons-material/Percent';
import ShieldIcon from '@mui/icons-material/Shield';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PeopleIcon from '@mui/icons-material/People';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/VOTOlogo.png';
import PaymentsIcon from '@mui/icons-material/Payments';
import InfoIcon from '@mui/icons-material/Info';
import BuildIcon from '@mui/icons-material/Build';
import WorkIcon from '@mui/icons-material/Work';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
// ✅ Import icons for Agent Details and User Monitor
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

interface SlideMenuProps {
  mobileOpen: boolean;
  onToggle: () => void;
}

type PermMap = Record<string, { canView: boolean; canWrite: boolean }>;

const ALL_MENUS = [
  { id: 'dashboard',                    name: 'Dashboard',                    path: '/adminDashboard',             icon: <DashboardCustomizeOutlinedIcon />, group: 'regular' },
  { id: 'user_list',                    name: 'User List',                    path: '/Userlist',                   icon: <GroupIcon />,                     group: 'regular' },
  { id: 'order_management',             name: 'Order Management',             path: '/adminOrderManagement',       icon: <GavelIcon />,                     group: 'regular' },
  { id: 'bulk_order_management',        name: 'Bulk Order Request',           path: '/bulkOrderManagement',        icon: <ShoppingCartIcon />,              group: 'regular' },
  { id: 'return_process_management',    name: 'Return Process Management',    path: '/returnprocessManagement',    icon: <AssignmentReturnIcon />,          group: 'regular' },
  { id: 'review',                       name: 'Review',                       path: '/review',                     icon: <StarsIcon />,                     group: 'regular' },
  { id: 'guest_order_list',             name: 'Guest User Details',           path: '/guestOrderlist',             icon: <AccountCircleIcon />,             group: 'regular' },
  { id: 'guest_user_order',             name: 'Guest Users Order List',       path: '/guestUserOrder',             icon: <PeopleAltIcon />,                 group: 'regular' },
  { id: 'set_credit',                   name: 'Set Credit for User',          path: '/SetCredit',                  icon: <CreditScoreOutlinedIcon />,       group: 'regular' },
  { id: 'pickupPending',                name: 'Set to Agent Pick UP',         path: '/pickupPending',              icon: <AutoFixHighIcon />,               group: 'regular' },
  { id: 'deal_of_the_day',              name: 'Deal of the Day',              path: '/dealoftheday',               icon: <AutoAwesomeIcon />,               group: 'regular' },
  { id: 'admin_rewards',                name: 'User Reward Management',       path: '/AdminRewards',               icon: <ManageAccountsIcon />,            group: 'regular' },
  { id: 'flash_sale',                   name: 'Flash Sale',                   path: '/flashSale',                  icon: <Whatshot />,                      group: 'regular' },
  { id: 'delivery_settings',            name: 'Delivery Settings',            path: '/deliverySettings',           icon: <SettingsIcon />,                  group: 'regular' },
  { id: 'tax_settings',                 name: 'Tax Settings',                 path: '/taxSettings',                icon: <PercentIcon />,                   group: 'regular' },
  { id: 'product_management',           name: 'Manage Product List',          path: '/productManagement',          icon: <InventoryIcon />,                 group: 'master' },
  { id: 'bundle_management',            name: 'Bundle Management',            path: '/bundleManagment',            icon: <LayersIcon />,                    group: 'master' },
  { id: 'category_management',          name: 'Category Management',          path: '/categoryManagement',         icon: <CategoryOutlinedIcon />,          group: 'master' },
  { id: 'subcategory_management',       name: 'Sub Category Management',      path: '/subcategorymanagement',      icon: <CategoryOutlinedIcon />,          group: 'master' },
  { id: 'unit_management',              name: 'Unit Management',              path: '/unitManagement',             icon: <AddCircleOutlineTwoToneIcon />,   group: 'master' },
  { id: 'delivery_agent_management',    name: 'Delivery Agent Management',    path: '/DeliveryAgentManagement',    icon: <AirportShuttleIcon />,            group: 'master' },
  { id: 'warehouse_management',         name: 'Warehouse Management',         path: '/WarehouseManagement',        icon: <WarehouseIcon />,                 group: 'master' },
  { id: 'banner_management',            name: 'Banner Management',            path: '/banner',                     icon: <ViewCarouselOutlinedIcon />,      group: 'master' },
  { id: 'product_warehouse_management', name: 'Product Warehouse Management', path: '/ProductWarehouseManagement', icon: <StorefrontIcon />,                group: 'master' },
  { id: 'delivery_management',          name: 'Delivery Management',          path: '/deliveryManagement',         icon: <AirportShuttleIcon />,            group: 'master' },
  //{ id: 'shipping_management',          name: 'Shipping Management',          path: '/shippingManagement',         icon: <PublicOutlinedIcon />,            group: 'master' },
  { id: 'extended_warranty',            name: 'Extended Warranty Management', path: '/extendedWarranty',           icon: <ShieldIcon />,                    group: 'master' },
  { id: 'ext_warranty_products',        name: 'Ext. Warranty Products List',  path: '/extWarrantyProducts',        icon: <ShieldIcon />,                    group: 'regular'  },
  { id: 'reward_management',            name: 'Reward Amount Conversions',    path: '/rewardManagement',           icon: <MilitaryTechIcon />,              group: 'master' },
  { id: 'reward_settings_management',   name: 'Reward Point Settings',        path: '/RewardSettingsManagement',   icon: <CardGiftcardIcon />,              group: 'master' },
  { id: 'coupon_management',            name: 'Coupon Management',            path: '/couponManagement',           icon: <DiscountIcon />,                  group: 'coupon' },
  { id: 'admin_coupon_users',           name: 'Coupons Users List',           path: '/AdminCouponUsers',           icon: <PeopleAltIcon />,                 group: 'coupon' },
  { id: 'admin_user_list',              name: 'BackOffice User List',         path: '/adminUserList',              icon: <PeopleAltIcon />,                 group: 'admin'  },
  { id: 'role_master',                  name: 'Role Master',                  path: '/roleMaster',                 icon: <SecurityIcon />,                  group: 'admin'  },
  { id: 'role_mapping',                 name: 'Role Mapping',                 path: '/roleMapping',                icon: <AssignmentIndIcon />,             group: 'admin'  },
  { id: 'smtp_settings',                name: 'SMTP Settings',                path: '/smtpsettings',               icon: <EmailIcon />,                     group: 'global_settings' },
  { id: 'site_settings',                name: 'Site Settings',                path: '/siteSettings',               icon: <LanguageIcon />,                  group: 'global_settings' },
  { id: 'cash_on_delivery',             name: 'Cash on Delivery',             path: '/cashOnDelivery',             icon: <PaymentsIcon />,                  group: 'global_settings' },
  { id: 'about_us',                     name: 'About Us',                     path: '/aboutUsPage',                icon: <InfoIcon />,                      group: 'global_settings' },
  { id: 'services',                     name: 'Services',                     path: '/servicePage',                icon: <BuildIcon />,                     group: 'global_settings' },
  { id: 'reports_management',           name: 'Reports Management',           path: '/reportsManagement',          icon: <AssessmentIcon />,                group: 'master' },
  { id: 'reports_list',                 name: 'Reports List',                 path: '/reportsList',                icon: <ListAltIcon />,                   group: 'regular' },
  { id: 'user_wallet',                  name: 'User Wallet',                  path: '/userWallet',                 icon: <AccountBalanceWalletIcon />,      group: 'regular' },
  { id: 'refer_friend',                 name: 'Refer a Friend',               path: '/referFriend',                icon: <PeopleIcon />,                    group: 'regular' },
  { id: 'agent_details',                name: 'Agent Details',                path: '/agentDetails',               icon: <AssignmentIndOutlinedIcon />,     group: 'regular' },
  { id: 'user_monitor',                 name: 'User Monitor',                 path: '/userMonitor',                icon: <MonitorHeartIcon />,              group: 'regular' },
  { id: 'career_management',            name: 'Career Management',            path: '/careerManagement',           icon: <WorkIcon />,                      group: 'master'  },
  { id: 'membership_plan_management',   name: 'Membership Plans',             path: '/membershipPlanManagement',   icon: <WorkspacePremiumIcon />,          group: 'master'  },
  { id: 'support_management',           name: 'Customer Support',             path: '/supportManagement',          icon: <HeadsetMicIcon />,                group: 'regular' },
] as const;

// ── Path-to-group helpers ─────────────────────────────────────────────────────
const MASTER_PATHS = ALL_MENUS.filter(m => m.group === 'master').map(m => m.path);
const COUPON_PATHS = ALL_MENUS.filter(m => m.group === 'coupon').map(m => m.path);
const ADMIN_PATHS  = ALL_MENUS.filter(m => m.group === 'admin').map(m => m.path);
const GLOBAL_PATHS = ALL_MENUS.filter(m => m.group === 'global_settings').map(m => m.path);
// Rewards live inside Master
const REWARDS_PATHS = ['/rewardManagement', '/RewardSettingsManagement'];

function isActiveIn(paths: string[], pathname: string) {
  return paths.includes(pathname);
}

function parseRights(rights: string | string[]): { canView: boolean; canWrite: boolean } {
  const arr = Array.isArray(rights)
    ? rights.map(r => r.trim().toLowerCase())
    : rights.split(',').map(r => r.trim().toLowerCase());
  return {
    canView:  arr.includes('view'),
    canWrite: arr.some(r => ['add', 'edit', 'delete', 'write'].includes(r)),
  };
}

function parsePermissions(
  moduleOrScreen: Record<string, string | string[]> | string | null | undefined
): PermMap {
  if (!moduleOrScreen) return {};
  const permMap: PermMap = {};
  if (moduleOrScreen === 'all') {
    ALL_MENUS.forEach(({ id }) => { permMap[id] = { canView: true, canWrite: true }; });
    return permMap;
  }
  if (typeof moduleOrScreen === 'object' && !Array.isArray(moduleOrScreen)) {
    Object.entries(moduleOrScreen).forEach(([menuId, rightsVal]) => {
      permMap[menuId] = parseRights(rightsVal as string | string[]);
    });
    return permMap;
  }
  if (typeof moduleOrScreen === 'string') {
    try { return parsePermissions(JSON.parse(moduleOrScreen)); }
    catch {
      moduleOrScreen.split(',').forEach(id => {
        const t = id.trim();
        if (t) permMap[t] = { canView: true, canWrite: false };
      });
    }
  }
  return permMap;
}

// ─────────────────────────────────────────────────────────────────
const SlideMenu: React.FC<SlideMenuProps> = ({ mobileOpen, onToggle }) => {
  const location  = useLocation();
  const navigate  = useNavigate();
  const pathname  = location.pathname;

  // Open states start false; they get set to true once permissions load
  // (see the useEffect that watches permissionsLoaded below).
  const [showMasterMenu,         setShowMasterMenu]         = useState(false);
  const [showCouponsMenu,        setShowCouponsMenu]        = useState(false);
  const [showAdminUsersMenu,     setShowAdminUsersMenu]     = useState(false);
  const [showGlobalSettingsMenu, setShowGlobalSettingsMenu] = useState(false);
  const [showRewardsSubMenu,     setShowRewardsSubMenu]     = useState(false);

  const [permMap,           setPermMap]           = useState<PermMap>({});
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);

  const listRef          = useRef<HTMLUListElement>(null);
  const activeItemRef    = useRef<HTMLDivElement>(null);
  const scrollPositionRef = useRef<number>(0);

  const rawRole = (
    localStorage.getItem('admin_type') ||
    localStorage.getItem('user_role')  ||
    localStorage.getItem('role')       ||
    ''
  ).toLowerCase().trim();

  const normalizeRole = (r: string) => {
    if (!r || r === 'new' || r === 'unknown') return 'admin';
    if (r.includes('super')) return 'super_admin';
    if (r === 'operation' || r === 'vendor') return r;
    return 'admin';
  };

  const userRole     = normalizeRole(rawRole);
  const isSuperAdmin = userRole === 'super_admin';
  const isAdmin      = userRole === 'admin';
  const isOperation  = userRole === 'operation';
  const isVendor     = userRole === 'vendor';
  const displayRole  = localStorage.getItem('role') || rawRole || 'Admin';

  // ── Expand the correct group whenever permissions finish loading (so
  //    conditional groups like Coupons/Admin/GlobalSettings are mounted
  //    by the time we try to open them) OR whenever the route changes.
  useEffect(() => {
    if (!permissionsLoaded) return;          // wait until groups are actually rendered
    if (isActiveIn(MASTER_PATHS,  pathname)) setShowMasterMenu(true);
    if (isActiveIn(COUPON_PATHS,  pathname)) setShowCouponsMenu(true);
    if (isActiveIn(ADMIN_PATHS,   pathname)) setShowAdminUsersMenu(true);
    if (isActiveIn(GLOBAL_PATHS,  pathname)) setShowGlobalSettingsMenu(true);
    if (isActiveIn(REWARDS_PATHS, pathname)) {
      setShowMasterMenu(true);
      setShowRewardsSubMenu(true);
    }
  }, [pathname, permissionsLoaded]);

  // ── After permissions load AND the relevant submenu has expanded, scroll
  //    the active item into view. Depend on ALL open-state flags so this
  //    re-fires the moment the correct group actually opens (not before).
  useEffect(() => {
    if (!permissionsLoaded) return;
    // Wait for MUI Collapse animation to finish (default 300ms) + buffer.
    const id = setTimeout(() => {
      if (activeItemRef.current) {
        activeItemRef.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, 400);
    return () => clearTimeout(id);
  }, [
    permissionsLoaded,
    pathname,
    showMasterMenu,
    showCouponsMenu,
    showAdminUsersMenu,
    showGlobalSettingsMenu,
    showRewardsSubMenu,
  ]);

  useEffect(() => {
    if (isOperation) {
      const allowed = ['/productManagement', '/adminOrderManagement', '/bulkOrderManagement'];
      if (!allowed.includes(pathname)) navigate('/productManagement', { replace: true });
    }
    if (isVendor && !['/productManagement', '/bundleManagment', '/bulkOrderManagement', '/returnprocessManagement'].includes(pathname)) {
      navigate('/productManagement', { replace: true });
    }
  }, [isOperation, isVendor, pathname, navigate]);

  useEffect(() => {
    const build = async () => {
      const setFull = (): PermMap => {
        const m: PermMap = {};
        ALL_MENUS.forEach(({ id }) => { m[id] = { canView: true, canWrite: true }; });
        return m;
      };

      let resolved: PermMap = {};

      if (isSuperAdmin) {
        resolved = setFull();
      } else {
        const savedRaw = localStorage.getItem('admin_permissions');
        if (savedRaw && savedRaw !== 'null' && savedRaw !== 'undefined') {
          try { resolved = parsePermissions(JSON.parse(savedRaw)); }
          catch { resolved = setFull(); }
        } else {
          const token  = localStorage.getItem('admin_token');
          const roleId = localStorage.getItem('admin_role_id');
          if (!token || !roleId || roleId === 'null') {
            resolved = setFull();
          } else {
            try {
              const res  = await fetch(`${import.meta.env.VITE_API_URL}/api/auth/permissions`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, authkey: import.meta.env.VITE_AUTH_KEY },
                body: JSON.stringify({ role_id: Number(roleId) }),
              });
              const data = await res.json();
              if (!data.error && data.permissions?.length > 0) {
                data.permissions.forEach((perm: any) => {
                  if (perm.module_or_screen) resolved = { ...resolved, ...parsePermissions(perm.module_or_screen) };
                });
              } else {
                resolved = setFull();
              }
            } catch { resolved = setFull(); }
          }
        }
      }

      setPermMap(resolved);
      localStorage.setItem('admin_perm_map', JSON.stringify(resolved));
      setPermissionsLoaded(true);
    };

    build();
  }, [userRole]);

  const canView  = useCallback((id: string) => permMap[id]?.canView  ?? false, [permMap]);
  const canWrite = useCallback((id: string) => permMap[id]?.canWrite ?? false, [permMap]);
  const groupHasAccess = useCallback(
    (group: string) => ALL_MENUS.some(m => m.group === group && canView(m.id)),
    [canView]
  );

  const menuStyle = {
    py: 1.25,
    px: 2,
    borderRadius: '8px',
    mx: 1,
    mb: 0.5,
    color: '#4a4a4a',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    '&.Mui-selected': {
      backgroundColor: '#e8f0fe',
      color: '#1a5a9c',
      fontWeight: 600,
      '& .MuiListItemIcon-root': {
        color: '#1a5a9c',
      },
      '& .MuiListItemText-primary': {
        fontWeight: 600,
      },
    },
  };

  const handleMenuClick = () => {
    if (listRef.current) {
      scrollPositionRef.current = listRef.current.scrollTop;
    }
  };

  const handleMenuMouseDown = () => {
    if (listRef.current) {
      scrollPositionRef.current = listRef.current.scrollTop;
    }
  };

  // ── MenuRow – attaches activeItemRef when this item is selected so the
  //    scroll-into-view effect can target it directly.
  const MenuRow = ({
    id, name, path, icon, indent = false,
  }: { id: string; name: string; path: string; icon: React.ReactNode; indent?: boolean }) => {
    const isSelected = pathname === path;

    if (!canView(id)) return null;

    return (
      <ListItemButton
        ref={isSelected ? activeItemRef : undefined}
        component={Link}
        to={path}
        selected={isSelected}
        onClick={handleMenuClick}
        onMouseDown={handleMenuMouseDown}
        sx={{ ...menuStyle, ...(indent ? { pl: 5 } : {}) }}
      >
        <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>{icon}</ListItemIcon>
        <ListItemText
          primary={name}
          primaryTypographyProps={{
            fontSize: '0.9rem',
            fontWeight: isSelected ? 600 : 400,
            color: 'inherit'
          }}
        />
      </ListItemButton>
    );
  };

  const SubMenuGroup = ({
    label, icon, open, onToggle: toggle, children,
  }: { label: string; icon: React.ReactNode; open: boolean; onToggle: () => void; children: React.ReactNode }) => (
    <>
      <ListItemButton onClick={toggle} sx={menuStyle}>
        <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>{icon}</ListItemIcon>
        <ListItemText
          primary={label}
          primaryTypographyProps={{
            fontSize: '0.95rem',
            fontWeight: 600,
            color: '#2c3e50'
          }}
        />
        {open ? <ExpandLessIcon sx={{ color: '#6d7175' }} /> : <ExpandMoreIcon sx={{ color: '#6d7175' }} />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{
          backgroundColor: '#fafafa',
          borderRadius: '4px',
          mx: 1,
          mb: 0.5,
        }}>
          {children}
        </List>
      </Collapse>
    </>
  );

  const RewardsSubMenu = () => {
    const hasRewardManagement = canView('reward_management');
    const hasRewardSettings   = canView('reward_settings_management');

    if (!hasRewardManagement && !hasRewardSettings) return null;

    return (
      <>
        <ListItemButton
          onClick={() => setShowRewardsSubMenu(prev => !prev)}
          sx={{ ...menuStyle, pl: 4 }}
        >
          <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>
            <CardGiftcardIcon />
          </ListItemIcon>
          <ListItemText
            primary="Rewards"
            primaryTypographyProps={{
              fontSize: '0.9rem',
              fontWeight: 500,
              color: '#4a4a4a'
            }}
          />
          {showRewardsSubMenu ? <ExpandLessIcon sx={{ color: '#6d7175' }} /> : <ExpandMoreIcon sx={{ color: '#6d7175' }} />}
        </ListItemButton>
        <Collapse in={showRewardsSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ backgroundColor: '#fafafa', borderRadius: '4px', mx: 1 }}>
            {hasRewardManagement && (
              <ListItemButton
                ref={pathname === '/rewardManagement' ? activeItemRef : undefined}
                component={Link}
                to="/rewardManagement"
                selected={pathname === '/rewardManagement'}
                onClick={handleMenuClick}
                onMouseDown={handleMenuMouseDown}
                sx={{ ...menuStyle, pl: 6 }}
              >
                <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>
                  <MilitaryTechIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Reward Amount Conversions"
                  primaryTypographyProps={{ fontSize: '0.85rem' }}
                />
              </ListItemButton>
            )}
            {hasRewardSettings && (
              <ListItemButton
                ref={pathname === '/RewardSettingsManagement' ? activeItemRef : undefined}
                component={Link}
                to="/RewardSettingsManagement"
                selected={pathname === '/RewardSettingsManagement'}
                onClick={handleMenuClick}
                onMouseDown={handleMenuMouseDown}
                sx={{ ...menuStyle, pl: 6 }}
              >
                <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>
                  <CardGiftcardIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Reward Point Settings"
                  primaryTypographyProps={{ fontSize: '0.85rem' }}
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>
      </>
    );
  };

  return (
    <Box sx={{ width: 260, height: '100vh', backgroundColor: '#fff', borderRight: '1px solid #e0e0e0', display: 'flex', flexDirection: 'column', overflow: 'hidden', position: 'relative' }}>
      <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <img src={logo} alt="VOTO Logo" style={{ height: 40 }} />
        {mobileOpen && <IconButton onClick={onToggle} size="small"><CloseIcon /></IconButton>}
      </Box>

      {/* Role chip */}
      {permissionsLoaded && (
        <Box sx={{ px: 2, pt: 2, pb: 1 }}>
          <Chip
            icon={
              isVendor     ? <StorefrontIcon        sx={{ fontSize: 18, color: '#fff !important' }} /> :
              isSuperAdmin ? <AdminPanelSettingsIcon sx={{ fontSize: 18, color: '#fff !important' }} /> :
              isAdmin      ? <SecurityIcon           sx={{ fontSize: 18, color: '#fff !important' }} /> :
                             <AssignmentIndIcon      sx={{ fontSize: 18, color: '#fff !important' }} />
            }
            label={displayRole}
            sx={{
              width: '100%',
              backgroundColor: isVendor ? '#4caf50' : isSuperAdmin ? '#f44336' : isAdmin ? '#2196f3' : '#ff9800',
              color: '#fff', fontWeight: 600, fontSize: '0.875rem', textTransform: 'capitalize',
            }}
          />
        </Box>
      )}

      {/* Spinner overlay */}
      {!permissionsLoaded && (
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff', zIndex: 10 }}>
          <CircularProgress size={28} sx={{ color: '#008060' }} />
        </Box>
      )}

      {/* Menu list – always mounted to preserve scroll position */}
      <List
        ref={listRef}
        onScroll={() => {
          if (listRef.current) {
            scrollPositionRef.current = listRef.current.scrollTop;
          }
        }}
        sx={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          pt: 1,
          scrollBehavior: 'instant',
          overflowAnchor: 'none',
          '&::-webkit-scrollbar': { width: '6px' },
          '&::-webkit-scrollbar-thumb': { backgroundColor: '#bbb', borderRadius: '3px' },
        }}
      >
        <MenuRow id="dashboard" name="Dashboard" path="/adminDashboard" icon={<DashboardCustomizeOutlinedIcon />} />
        <MenuRow id="user_list" name="User List"  path="/Userlist"       icon={<GroupIcon />} />
        <MenuRow id="tax_settings" name="Tax Settings" path="/taxSettings" icon={<PercentIcon />} />

        {groupHasAccess('master') && (
          <SubMenuGroup label="Master" icon={<LayersIcon />} open={showMasterMenu} onToggle={() => setShowMasterMenu(p => !p)}>
            <MenuRow id="product_management"           name="Manage Product List"          path="/productManagement"          icon={<InventoryIcon />}                indent />
            <MenuRow id="bundle_management"            name="Bundle Management"            path="/bundleManagment"            icon={<LayersIcon />}                   indent />
            <MenuRow id="category_management"          name="Category Management"          path="/categoryManagement"         icon={<CategoryOutlinedIcon />}         indent />
            <MenuRow id="subcategory_management"       name="Sub Category Management"      path="/subcategorymanagement"      icon={<CategoryOutlinedIcon />}         indent />
            <MenuRow id="unit_management"              name="Unit Management"              path="/unitManagement"             icon={<AddCircleOutlineTwoToneIcon />}  indent />
            <MenuRow id="delivery_agent_management"    name="Delivery Agent Management"    path="/DeliveryAgentManagement"    icon={<AirportShuttleIcon />}           indent />
            <MenuRow id="warehouse_management"         name="Warehouse Management"         path="/WarehouseManagement"        icon={<WarehouseIcon />}                indent />
            <MenuRow id="banner_management"            name="Banner Management"            path="/banner"                     icon={<ViewCarouselOutlinedIcon />}     indent />
            <MenuRow id="product_warehouse_management" name="Product Warehouse Management" path="/ProductWarehouseManagement" icon={<StorefrontIcon />}               indent />
            <MenuRow id="delivery_management"          name="Delivery Management"          path="/deliveryManagement"         icon={<AirportShuttleIcon />}           indent />
            <MenuRow id="shipping_management"          name="Shipping Management"          path="/shippingManagement"         icon={<PublicOutlinedIcon />}           indent />
            <MenuRow id="extended_warranty"            name="Extended Warranty Management" path="/extendedWarranty"           icon={<ShieldIcon />}                   indent />
            <MenuRow id="career_management"            name="Career Management"            path="/careerManagement"           icon={<WorkIcon />}                     indent />
            <MenuRow id="membership_plan_management"   name="Membership Plans"             path="/membershipPlanManagement"   icon={<WorkspacePremiumIcon />}         indent />
            <MenuRow id="reports_management"           name="Reports Management"           path="/reportsManagement"          icon={<AssessmentIcon />}               indent />
            <RewardsSubMenu />
          </SubMenuGroup>
        )}

        {ALL_MENUS.filter(m => m.group === 'regular' && !['dashboard', 'user_list', 'tax_settings'].includes(m.id)).map(m => (
          <MenuRow key={m.id} id={m.id} name={m.name} path={m.path} icon={m.icon} />
        ))}

        {groupHasAccess('coupon') && (
          <SubMenuGroup label="Coupons" icon={<DiscountIcon />} open={showCouponsMenu} onToggle={() => setShowCouponsMenu(p => !p)}>
            {ALL_MENUS.filter(m => m.group === 'coupon').map(m => (
              <MenuRow key={m.id} id={m.id} name={m.name} path={m.path} icon={m.icon} indent />
            ))}
          </SubMenuGroup>
        )}

        {groupHasAccess('admin') && (
          <SubMenuGroup label="BackOffice Users" icon={<ManageAccountsIcon />} open={showAdminUsersMenu} onToggle={() => setShowAdminUsersMenu(p => !p)}>
            {ALL_MENUS.filter(m => m.group === 'admin').map(m => (
              <MenuRow key={m.id} id={m.id} name={m.name} path={m.path} icon={m.icon} indent />
            ))}
          </SubMenuGroup>
        )}

        {groupHasAccess('global_settings') && (
          <SubMenuGroup label="Global Settings" icon={<SettingsIcon />} open={showGlobalSettingsMenu} onToggle={() => setShowGlobalSettingsMenu(p => !p)}>
            {ALL_MENUS.filter(m => m.group === 'global_settings').map(m => (
              <MenuRow key={m.id} id={m.id} name={m.name} path={m.path} icon={m.icon} indent />
            ))}
          </SubMenuGroup>
        )}
      </List>
    </Box>
  );
};

export default SlideMenu;